import { defineDocStore } from '@/stores/base/baseDocStore'
import { type CallLog } from '@/types/CallLog'
import { CallLogModel } from '@/models/CallLogModel'

export const useCallLogStore = defineDocStore<CallLog>({
  entityName: 'callLog',
  collection: 'call_logs',
  model: CallLogModel,
  initialState: {
    filters: {
      global: { value: null, matchMode: 'contains' },
      direction: { value: null, matchMode: 'equals' },
      notes: { value: null, matchMode: 'contains' },
      personId: { value: null, matchMode: 'equals' },
      organizationId: { value: null, matchMode: 'equals' },
    },
    sort: { field: 'timestamp', order: -1 },
  },
})
